import _ from "lodash";
import { EMPTY_CELL } from "../constants";

const getTagCellProps = ({ node, cellConfig, customConfig }) => {
  const { styles } = cellConfig || {};
  const {
    property,
    showEmptyCellAsFallback = false,
    getValue,
    getCellConfigFromValue = () => {},
  } = customConfig || {};

  const value = _.get(node, property);

  const options = _.reduce(
    value,
    (acc, tag) => {
      let value = tag;
      if (getValue) value = getValue(tag);
      const { id, name, label } = value;
      value = {
        id,
        label: label || name,
      };
      if (value.label) acc.push(value);
      return acc;
    },
    []
  );

  const overriddenCellConfig = getCellConfigFromValue({
    value: options,
    originalValue: value,
  });

  if ((_.isArray(options) && _.isEmpty(options)) || !options) {
    if (showEmptyCellAsFallback) {
      return { ...EMPTY_CELL, ...overriddenCellConfig, styles };
    }
  }

  return {
    ...cellConfig,
    validInputs: {
      options,
    },
    value: options,
    ...overriddenCellConfig,
  };
};

export default getTagCellProps;
